import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip',
		defaultMessage: 'Go back',
		description: 'Tooltip for the sidebar navigation back button',
	},
	label: {
		id: 'navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label',
		defaultMessage: 'Navigate back to the previous page',
		description: 'Label for the sidebar navigation back button',
	},
});
